export var ACTIONS = Object.freeze({
  CHANGE_BRAND: 'CHANGE_BRAND',
  CHANGE_MODEL: 'CHANGE_MODEL',
  CHANGE_VERSION: 'CHANGE_VERSION',
  CHANGE_YEAR: 'CHANGE_YEAR',
  FETCH_START: 'FETCH_START',
  RELOAD_PAGE_START: 'RELOAD_PAGE_START',
  RESET_ALL: 'RESET_ALL',
  SAVE_SEARCH_URL: 'SAVE_SEARCH_URL',
  SET_CAR_PLATE: 'SET_CAR_PLATE',
  SET_COMPATIBILITY: 'SET_COMPATIBILITY',
  SET_DATA: 'SET_DATA',
  SET_ERROR: 'SET_ERROR',
  SET_LOADING: 'SET_LOADING',
  SET_PLATE_ERROR: 'SET_PLATE_ERROR',
  SET_SHOW_SUMMARY: 'SET_SHOW_SUMMARY',
  SET_VEHICLE_DETAILS: 'SET_VEHICLE_DETAILS'
});
export var ENTITIES = Object.freeze({
  BRANDS: 'brands',
  MODELS: 'models',
  VERSIONS: 'versions',
  YEARS: 'years'
});
export var EVENTS = Object.freeze({
  HANDLE_FORM_FIELDCHANGE: 'cardan:handle:formfieldchange',
  HANDLE_FORM_RESET: 'cardan:handle:formreset',
  HANDLE_FORM_SEARCH: 'cardan:handle:formsearch',
  HANDLE_SHOW_SUMMARY: 'cardan:handle:summary'
});
export var VEHICLE_ITEMS = Object.freeze(['brand', 'model', 'version', 'year']);
export var VEHICLE_SEARCH_FILTERS = VEHICLE_ITEMS.map(function (item) {
  return "car_".concat(item);
});